import React from 'react'
import PlaceholderFactory from '../../../page-components/PlaceholderFactory'
import styles from './styles.module.scss'
import TableOfContents from '../TableOfContents'
import { TableOfContentsStyles } from '../../../constants/table-of-contents-styles'
import { Item } from '@sitecore-jss/sitecore-jss-react'

type ArticleBodyProps = {
  heading: JSX.Element
  meta: JSX.Element | null
  description: JSX.Element
  footNote: JSX.Element
  tableOfContents: JSX.Element | null
  tableOfContentsStyle: Item
}

const ArticleBody = ({
  heading,
  meta,
  description,
  footNote,
  tableOfContents,
  tableOfContentsStyle
}: ArticleBodyProps) => {
  var tocMode = tableOfContentsStyle?.id ?? ""
  
  var swappableContent = <></>
  if(tocMode === TableOfContentsStyles.HIDDEN) {
    swappableContent = 
    <>
        <div className={styles.description}>{description}</div>
    </>
  }
  if (tocMode === TableOfContentsStyles.SHOWABOVE) {
    swappableContent = 
    <>
      {tableOfContents && <>{tableOfContents}</>}
      <div className={styles.description}>{description}</div>
    </>
  }
  if (tocMode === TableOfContentsStyles.SHOWBELOW) {
    swappableContent = 
    <>
      <div className={styles.description}>{description}</div>
      {tableOfContents && <>{tableOfContents}</>}
    </>
  }


  return (
    <article>
      {heading}
      {meta && <div className={styles.meta}>{meta}</div>}
      {swappableContent}
      <PlaceholderFactory name="Blog-Placeholder" />
      {footNote}
    </article>
  )
}

export default ArticleBody
